// Mock data for Clik Technologies website

export const stats = [
  { value: '15', label: 'ENTERPRISE CLIENTS', suffix: '+' },
  { value: '100', label: 'PROJECTS DELIVERED', suffix: '+' },
  { value: '20', label: 'A ROUND STARTUPS', suffix: '+' },
  { value: '6-9', label: 'MONTHS AVG ENGAGEMENT', suffix: '' }
];

export const clientLogos = [
  { name: 'Newmark', url: 'https://clik.ai/images/ClientLogos/newmark.svg' },
  { name: 'Lument', url: 'https://clik.ai/images/ClientLogos/lument.svg' },
  { name: 'BWE', url: 'https://clik.ai/images/ClientLogos/bwe-blue.svg' },
  { name: 'Merchants Capital', url: 'https://clik.ai/images/ClientLogos/merchant-capital.png' },
  { name: 'Colliers', url: 'https://clik.ai/images/ClientLogos/colliers.png' },
  { name: 'ACORE Capital', url: 'https://clik.ai/images/ClientLogos/acore-capital.png' },
  { name: 'Columbia National', url: 'https://clik.ai/images/ClientLogos/Columbia_noational.png' },
  { name: 'Webster Bank', url: 'https://clik.ai/images/ClientLogos/webster-bank.svg' },
  { name: 'Northmarq', url: 'https://clik.ai/images/ClientLogos/northmarq.svg' },
  { name: 'Heitman', url: 'https://clik.ai/images/ClientLogos/hietman.svg' },
  { name: 'LoginRadius', url: '/loginradius-logo.png' },
  { name: 'Brysk', url: 'https://logo.clearbit.com/brysk.com' },
  { name: 'Tonmous', url: 'https://logo.clearbit.com/tonmous.ca' }
];

export const testimonials = [
  {
    id: 1,
    quote: "Clik Technologies delivered our AI Auth Studio with exceptional quality and speed. Their team understood our vision perfectly and brought specialized AI expertise we didn't have in-house. They're now our go-to partner for complex engineering challenges.",
    author: 'Rakesh Soni',
    position: 'CEO',
    company: 'LoginRadius',
    companyLogo: '/loginradius-logo.png',
    avatar: '/rakesh-soni.webp'
  },
  {
    id: 2,
    quote: "Clik Technologies built us a risk surveillance platform that replaced months of manual spreadsheet work with real-time automated analytics. Their predictive default models now flag at-risk loans 3–6 months before traditional indicators — that's a game-changer for how we manage portfolio risk.",
    author: 'Joseph Iorizzo',
    position: 'Managing Director, Portfolio Analytics & Credit Research',
    company: 'Leading US Bank',
    companyLogo: null,
    avatar: '/joseph-iorizzo.webp'
  }
];

export const partnerFunds = [
  { name: 'Y Combinator', url: 'https://cdn.prod.website-files.com/668b008ec39b281a2411a5fd/66a7fe5f3a161646ecd766bc_YCombinator.svg' },
  { name: 'Sequoia', url: 'https://cdn.prod.website-files.com/668b008ec39b281a2411a5fd/668b38ce134dc172d67f6874_sequoia.svg' },
  { name: 'Andreessen Horowitz', url: 'https://cdn.prod.website-files.com/668b008ec39b281a2411a5fd/66a7fe5ea82a55447ad1a6a0_Andreessen%20Horowitz.svg' },
  { name: 'Coinbase Ventures', url: 'https://cdn.prod.website-files.com/668b008ec39b281a2411a5fd/66a7fe5eb6d8fedc796bc20f_coinbase%20ventures.svg' },
  { name: 'General Catalyst', url: 'https://cdn.prod.website-files.com/668b008ec39b281a2411a5fd/66a7fe5eac143605d74ee61e_general%20catalyst.svg' },
  { name: 'Polychain Capital', url: 'https://cdn.prod.website-files.com/668b008ec39b281a2411a5fd/66a7fe5f31aaa58bdfbe2328_polychain%20capital.svg' },
  { name: 'Google Ventures', url: 'https://cdn.prod.website-files.com/668b008ec39b281a2411a5fd/66a7fe5e0c408056f8556f6c_google%20ventures.svg' },
  { name: 'Bain Capital', url: 'https://cdn.prod.website-files.com/668b008ec39b281a2411a5fd/66a7fe5e7492923cc7c848c9_Bain%20Capital.svg' },
  { name: 'Golden Ventures', url: 'https://cdn.prod.website-files.com/668b008ec39b281a2411a5fd/66a7fe5efb5f9190669758c6_golden%20ventures.svg' },
  { name: 'Electric Capital', url: 'https://cdn.prod.website-files.com/668b008ec39b281a2411a5fd/66a7fe5e814d1d65150038f7_electric%20captial.svg' },
  { name: 'Dragonfly', url: 'https://cdn.prod.website-files.com/668b008ec39b281a2411a5fd/66a7fe5e6acdd22638e9e077_dragonfly.svg' },
  { name: 'Paradigm', url: 'https://cdn.prod.website-files.com/668b008ec39b281a2411a5fd/66a7fe5fe1b84871203c36d3_paradigm.svg' }
];
